import styled from 'styled-components';
import { mq } from '@phishtool/ui';
export const StyledSelect = styled.select.withConfig({ displayName: "StyledSelect", componentId: "-1kx5zd8" }) `
  background-color: ${(props) => props.theme.colors.white};
  color: ${(props) => props.theme.body.textColor};
  border: 1px solid ${(props) => props.theme.colors.silverPearl};
  border-radius: ${(props) => props.theme.borderRadius.primary};
  font-size: 14px;
  height: 30px;
  padding: 0 2.5rem 0 ${(props) => props.theme.spacers.medium};
  appearance: none;
  outline: none;

  background-image: linear-gradient(45deg, transparent 50%, ${(props) => props.theme.colors.blueCrayola} 50%),
    linear-gradient(135deg, ${(props) => props.theme.colors.blueCrayola} 50%, transparent 50%),
    linear-gradient(to right, ${(props) => props.theme.colors.white}, ${(props) => props.theme.colors.white});
  background-position: calc(100% - 20px) 12px, calc(100% - 15px) 12px, calc(100% - 2.5em) 0.5em;
  background-size: 5px 5px, 5px 5px, 1px 1.5em;
  background-repeat: no-repeat;

  ${mq({
    width: ['100%', 'auto'],
})}
`;
export const StyledContentWrapper = styled.div.withConfig({ displayName: "StyledContentWrapper", componentId: "-yq21jj" }) `
  p,
  li {
    font-size: 14px;
    margin: 0 0 ${(props) => props.theme.spacers.large};
  }

  h3 {
    font-size: 18px;
    margin: 0 0 ${(props) => props.theme.spacers.large};
    padding: ${(props) => props.theme.spacers.xl} 0 0;
  }

  ul {
    padding: 0 0 0 ${(props) => props.theme.spacers.xl};
  }

  a {
    color: ${(props) => props.theme.body.textColor};
    text-decoration: underline;

    &:hover {
      color: ${(props) => props.theme.colors.celticBlue};
    }
  }

  table {
    border-spacing: 0;
    margin: 0 0 ${(props) => props.theme.spacers.large};
  }

  th {
    font-weight: 600;
  }

  th,
  td {
    font-size: 14px;
    border-bottom: 1px solid ${(props) => props.theme.body.textColor};
    padding: ${(props) => props.theme.spacers.small} ${(props) => props.theme.spacers.medium};
  }

  tbody tr:last-child td {
    border: none;
  }
`;
